<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="account-page">
        <account-left></account-left>
        <div class="act-page-right">
          <el-steps :active="active" align-center finish-status="success">
            <el-step title="Check"></el-step>
            <el-step title="Settings"></el-step>
            <el-step title="Finish"></el-step>
          </el-steps>
          <el-form :model="vcodeForm" :rules="vcrules" :ref="vcodeForm" class="ch-pass-form" v-if="active===0">
            <div class="telInfo">Your phone number{{ this.model.TEL }} </div>
            <el-form-item>
              <div class="form-group">
              <el-form-item prop="telVcode"><el-input v-model="vcodeForm.telVcode" placeholder="Please input the code"></el-input></el-form-item>
              <el-button v-if="disabled" icon="el-icon-message"
                         class="ve-code"
                         @click="getVcode">get code</el-button>
              <el-button v-if="!disabled" type="info" disabled class="ve-code">{{timer}}s</el-button>
              </div>
            </el-form-item>
            <el-button type="primary" @click="subVcode(vcodeForm)">submit</el-button>
          </el-form>
          <el-form :model="passWordForm" :rules="pwrules" :ref="passWordForm" class="ch-pass-form" v-if="active===1">
            <div class="frm-ti">New password</div>
            <el-form-item>
              <div class="input-password">
              <el-form-item prop="newPassWord"><el-input v-model="passWordForm.newPassWord" :type="typeofV" placeholder="New password"></el-input></el-form-item>
              <span class="icon iconfont icon-yanjing" v-show="!showPassValue" @click="hdPassSh"></span>
              <span class="icon iconfont icon-yanjing-biyan" v-show="showPassValue" @click="hdPassSh"></span>
              </div>
            </el-form-item>
            <el-button type="primary" @click="subPassWd(passWordForm)">submit</el-button>
          </el-form>
          <div class="ch-pass-form" v-if="active===2">
            <el-result icon="success" title="Login password updated successfully">
              <template slot="extra">
                <el-button type="primary" size="medium" @click="backRec">Log in again</el-button>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import AccountLeft from "common/other/AccountLeft";
import { Alert } from 'element-ui';
export default {
  name: "Cipher",
  components: {
    CommonHead,
    CommonFoot,
    AccountLeft,
  },
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter a new password'));
      } else {
        if(value.length !=value.replace(/[^\w]/g, '').length){
          callback(new Error('Can only be numbers and letters'));
        }
        callback();
      }
    };
    return {
      vcodeForm:{
        telVcode:'',
      },
      model: {},
      active: 0,
      vcrules:{
        telVcode:[
          {required: true,message: 'Please enter the mobile verification code',trigger: 'blur'},
        ],
      },
      passWordForm:{
        newPassWord:'',
      },
      showPassValue:true,      
      disabled:true,
      timer:60,
      typeofV:'password',
      pwrules:{
        newPassWord:[
          {required: true,validator: validatePass,trigger: 'blur'}
        ],
      },
    }
  },
  mounted: function () {
    let url = this.$bti.GetMember(null, true);
    this.http.postParam(url,{},"loading...").then((res) => {
      this.model = res.data;
    });
  },  
  methods:{
    getVcode:function(){
      let url = this.$bti.GetSmsForUpdatePassword(null, true);
      this.http
        .postParam(url,{
          "tel": this.model.TEL,
        },"loading...")
        .then((result) => {
          if (result.code!=1) {
            this.$message.error(result.info);
          } else {
            this.$message.success("SMS sent successfully");
            this.disabled = false;
            const authTimer = setInterval(() => {
              this.timer--;
              if (this.timer <= 0) {
                this.disabled = true;
                this.timer = 60;
                clearInterval(authTimer)
              }
            }, 1000);
          }
        });
    },
    subVcode:function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          let url = this.$bti.CheckSmsForUpdatePassword(null, true);
          this.http
            .postParam(url,{
              "tel": this.model.TEL,
              "msgCode": this.vcodeForm.telVcode,
              "pass": '',
              "SCHOOLID":'',
              "position":'',
            },"Verifying...")
            .then((result) => {
              if (result.code!=1) {
                this.$message.error(result.info);
              } else {
                this.active=1;
                this.$message({
                  message: 'Verification successful!',
                  type: 'success'
                });       
              }
            }); 
        } else {
          this.$message.error('Please check the input');
          return false;
        }
      });
    },
    subPassWd:function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          let url = this.$bti.CheckSmsForUpdatePassword(null, true);
          this.http
            .postParam(url,{
              "tel": this.model.TEL,
              "msgCode": this.vcodeForm.telVcode,
              "pass": this.passWordForm.newPassWord,
              "SCHOOLID":'',
              "position":'',
            },"Modifying...")
            .then((result) => {
              if (result.code!=1) {
                this.$message.error(result.info);
              } else {
                this.active=2;
                this.$message({
                  message: 'Modified successfully!',
                  type: 'success'
                }); 
                this.$store.commit("saveToken", "");      
              }
            }); 
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    backRec:function () {
      this.active = 0;
      //console.log("重新登录");
      window.location.href = "/login";
    },
    hdPassSh:function () {
      this.showPassValue = !this.showPassValue;
      if(this.showPassValue === true){
        this.typeofV = 'password';
      }else{
        this.typeofV = 'text';
      }
    },
  },
}
</script>

<style lang="css" scoped>
.ch-pass-form{
  padding-top: 50px;
  width: 350px;
  margin:0px auto;
}
  .telInfo{
    font-size: 16px;
    padding-bottom: 20px;
  }
  .form-group{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-wrap:nowrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    padding-bottom: 5px;
  }
.form-group .ve-code{
    width: 150px;
    margin-left: 15px;
  }
  .el-button{
    width: 100%;
  }
  .frm-ti{
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 20px;
  }
  .input-password{
    padding-bottom: 20px;
    position: relative;
  }
.input-password .icon{
  position: absolute;
  right:15px;
  top:3px;
  font-size: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/Cipher.vue